import dayjs from 'dayjs';
import envConfig from './envConfig';

// While impersonating, the global admin's own session is parked under these keys
// so it can be restored without forcing them to sign in again.
const impersonatorUserKey = `${envConfig.StoragePrefix}-impersonator-user`;
const impersonatorTokenKey = `${envConfig.StoragePrefix}-impersonator-token`;

const userKey = `${envConfig.StoragePrefix}-user`;
const tokenKey = `${envConfig.StoragePrefix}-token`;
const tokenDateKey = `${envConfig.StoragePrefix}-token-date`;

export function getImpersonator() {
  try {
    const stored = window.localStorage.getItem(impersonatorUserKey);
    return stored ? JSON.parse(stored) : null;
  } catch (e) {
    return null;
  }
}

export function isImpersonating() {
  return !!window.localStorage.getItem(impersonatorTokenKey);
}

/**
 * Parks the current admin session and swaps in the impersonated one.
 * Returns the impersonated profile so callers can push it into state.
 */
export function startImpersonation(profile, accessToken) {
  // Never overwrite an existing parked session, otherwise impersonating twice in
  // a row would strand the admin in the first impersonated account.
  if (!isImpersonating()) {
    window.localStorage.setItem(impersonatorUserKey, window.localStorage.getItem(userKey));
    window.localStorage.setItem(impersonatorTokenKey, window.localStorage.getItem(tokenKey));
  }

  window.localStorage.setItem(userKey, JSON.stringify(profile));
  window.localStorage.setItem(tokenKey, accessToken);
  window.localStorage.setItem(tokenDateKey, dayjs().toString());
  return profile;
}

/**
 * Restores the parked admin session. Returns the admin profile, or null when
 * there was nothing parked.
 */
export function stopImpersonation() {
  const adminUser = window.localStorage.getItem(impersonatorUserKey);
  const adminToken = window.localStorage.getItem(impersonatorTokenKey);

  window.localStorage.removeItem(impersonatorUserKey);
  window.localStorage.removeItem(impersonatorTokenKey);

  if (!adminUser || !adminToken) {
    return null;
  }

  window.localStorage.setItem(userKey, adminUser);
  window.localStorage.setItem(tokenKey, adminToken);
  window.localStorage.setItem(tokenDateKey, dayjs().toString());

  try {
    return JSON.parse(adminUser);
  } catch (e) {
    return null;
  }
}

/** Clears the parked session without restoring it, e.g. on sign out. */
export function clearImpersonation() {
  window.localStorage.removeItem(impersonatorUserKey);
  window.localStorage.removeItem(impersonatorTokenKey);
}
